"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsersJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const NewUsersChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/model/NewUsersChartSettingsJSONModel");
class NewUsersJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.lineTypeJSONModel = new LineTypeJSONModel_1.LineTypeJSONModel();
        this.chartSettingsJSONModel = new NewUsersChartSettingsJSONModel_1.NewUsersChartSettingsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.lineTypeJSONModel.reset();
            this.chartSettingsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.lineTypeJSONModel.overwriteFromSerializedState(serializedState.lineType);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                lineType: this.lineTypeJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getLineTypeJSONModel = () => this.lineTypeJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.NewUsersJSONModel = NewUsersJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
NewUsersJSONModel.isModelEmpty = (serializedState) => {
    return true;
};
NewUsersJSONModel.makeModelStateClean = (serializedState) => {
    const jsonModel = new NewUsersJSONModel(serializedState);
    if (jsonModel.getLineTypeJSONModel().getLineType() === "nonCumulative") {
        if (jsonModel.getChartSettingsJSONModel().getCumulativeGrowthPercent()) {
            jsonModel.getChartSettingsJSONModel().setCumulativeGrowthPercent(false);
        }
    }
    return jsonModel.serialize();
};
